import { useTranslation } from 'react-i18next';

export const MetadataConditionConnector = () => {
  const { t } = useTranslation('metadata_conditions');
  return (
    <span
      data-testid="metadata-condition-and"
      className="text-xs font-medium text-muted-foreground"
    >
      {t('and')}
    </span>
  );
};
